<template>
    <div  class="page_content" aria-label="career idea list Page Content">

		<div class="career_idea_list">
			<template v-if="careerIdeas.length > 0">
				<template v-for="careerIdea in careerIdeas">

					<div class="row data_row">
						<div class="data_row_title">
							<div class="col_title">
                                <template v-if="isCareerIdeaEnable">
    								<b-link @click="navigateToCareerIdea(careerIdea.uuid)">
    									{{careerIdea.title}}
    								</b-link>
								</template>
								<template v-else>
								    <div class="col_title">
								        {{careerIdea.title}}
								    </div>
								</template>
							</div>
							<div class="col_action" v-if="isCareerIdeaEnable">
								<span class="ic ico-edit" @click="editCareerIdea(careerIdea.uuid)" aria-label="edit" tabindex="0" title="edit this career idea"></span>
	                            <span class="ic icon-bin2" @click="showDeleteCareerIdeaConfirmBox(careerIdea.uuid, careerIdea.title)" aria-label="delete" tabindex="0" title="delete this career idea"></span>
							</div>
						</div>

						<div class="data_row_info">
							<div class="col_info">
								<template v-if="isCareerIdeaEnable">
    								<b-link class="col_connection" @click="navigateToCareerIdea(careerIdea.uuid)" aria-label="connection list">
    									<span class="icon ico-connection1"></span>
    									<span class="title ml-1" v-if="careerIdea.connectionCount > 1">Connections</span>
                                        <span class="title ml-1" v-else>Connection</span>
    									<span>{{careerIdea.connectionCount}}</span>
    								</b-link>
								</template>
								<template v-else>
								    <div class="col_connection" aria-label="connection list">
                                        <span class="icon ico-connection1"></span>
                                        <span class="title ml-1" v-if="careerIdea.connectionCount > 1">Connections</span>
                                        <span class="title ml-1" v-else>Connection</span>
                                        <span>{{careerIdea.connectionCount}}</span>
                                    </div>
								</template>
							</div>
							<div class="col_info">
								<div class="col_interest">
									<span v-if="careerIdea.interestLevel === '1'">High Interest</span>
									<span v-if="careerIdea.interestLevel === '2'">Medium Interest</span>
									<span v-if="careerIdea.interestLevel === '3'">Low Interest</span>
								</div>
							</div>
						</div>
					</div>

				</template>
			</template>

			<template v-else>
				<!--
				<div class="no_data_msg">
					<span>0 Career Ideas</span>
				</div>
				-->
			</template>
		</div>


    <div class="modal_container modal_alart confirm">
            <b-modal class="delete-folder-popup" ref="popupModal" :title="'Please Confirm!'" :header-bg-variant="'folder-delete-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                <div>
                    <span>{{ deleteMessage }}</span>
                </div>
              <div slot="modal-header" class="header-section">
                <div class="ic ic-hd"></div>
                <div class="head_txt">Please Confirm!</div>
                <button type="button" class="btn_close" @click="closeConfirmBox" aria-label="close">
                  <span class="ic-close"></span>
                </button>
              </div>
              <div slot="modal-footer" class="w-100">
                  <b-button @click="deleteCareerIdeaAndCloseConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
                  <b-button @click="closeConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
              </div>
            </b-modal>
        </div>


    </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'career-idea-list',
    props: ['isCareerIdeaEnable'],
    data () {
      return {
        careerIdeas: [],
        interestLevelOptions: [
          {value: '3', text: 'Low'},
          {value: '2', text: 'Medium'},
          {value: '1', text: 'High'}
        ],
        deleteMessage: '',
        careerIdeaIdToBeDeleted: '',
        careerIdeaTitleToBeDeleted: ''
      }
    },

    mounted () {
      this.populateCareerIdeas()
    },

    methods: {
      ...mapActions([
        'loadCareerIdeas',
        'deleteCareerIdeaDetail'
      ]),

      populateCareerIdeas () {
        this.loadCareerIdeas().then(res => {
          this.careerIdeas = res
        })
      },

      navigateToCareerIdea (uuid) {
        return this.$router.push({name: 'connection', params: {careerIdeaId: uuid}})
      },

      editCareerIdea (uuid) {
        return this.$router.push({name: 'careerIdeaEdit', params: {careerIdeaId: uuid}})
      },

      showDeleteCareerIdeaConfirmBox (careerIdeaUuid, careerIdeaTitle) {
        this.careerIdeaIdToBeDeleted = careerIdeaUuid
        this.careerIdeaTitleToBeDeleted = careerIdeaTitle
        this.$refs.popupModal.show()
        this.deleteMessage = 'Are you sure you want to delete "' + careerIdeaTitle + '" career idea?'
      },

      deleteCareerIdeaAndCloseConfirmBox () {
        this.$refs.popupModal.hide()
        this.deleteCareerIdea()
      },

      deleteCareerIdea () {
        if (this.careerIdeaIdToBeDeleted) {
          this.deleteCareerIdeaDetail(this.careerIdeaIdToBeDeleted).then(res => {
            if (res && res.status === 204) {
              this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: 'Career idea "' + this.careerIdeaTitleToBeDeleted + '" is deleted successfully.'
              })
              this.populateCareerIdeas()
            }
          })
        }
      },

      closeConfirmBox () {
        this.careerIdeaIdToBeDeleted = ''
        this.careerIdeaTitleToBeDeleted = ''
        this.$refs.popupModal.hide()
      }

    }
  }
</script>

<style scoped>
    select {
        width: 70px;
        height: 23px;
    }
</style>



// WEBPACK FOOTER //
// src/app/quest/components/CareerIdeaList.vue